import { useQuery } from "@tanstack/react-query";
import { Illuminate } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const FILTER_ILLUMINATE_PACKS_KEY = "filter_illuminate_packs";
const INITIAL_DATA = [];
const filterIlluminatePacks = async (filters) => {
  const filterArgs = {
    query: void 0,
    category: void 0,
    tags: void 0,
    inputType: filters.inputType,
    is_new: void 0,
    update_available: void 0,
    enabled: void 0,
    type: filters.type,
    include_deps: void 0
  };
  return Illuminate.filterPacks(...Object.values(filterArgs));
};
const useFilterIlluminatePacks = (filters = {}, enabled = true) => {
  const { data, isLoading } = useQuery({
    queryKey: [FILTER_ILLUMINATE_PACKS_KEY, filters.type, filters.inputType],
    queryFn: () => onError(filterIlluminatePacks(filters), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading Illuminate packs failed with: ${errorThrown}`);
      }
    }),
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading
  };
};
export default useFilterIlluminatePacks;
